import Request from './request'

const SimcardProfile = {
  getSimcardProfile(id, callback, bad_answer) {
    Request.get('simcard-profile/index/' + id).then(callback).catch(bad_answer)
  },
  getPagesSimcards (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard-profile/pages', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardList (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard-profile/list/' + params.page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardProfileGroups(callback) {
    Request.get('simcard-profile/groups').then(callback).catch(this.bad_answer)
  },
  getSimcardDevices (params, callback) {
    Request.post('simcard-profile/status-info', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardHistoryAction(params, callback) {
    Request.get('simcard-profile/actions-log', params).then(callback).catch(this.bad_answer)
  },
  getSimcardTariff(id, callback) {
    Request.get('simcard-profile/tariff/'+ id).then(callback).catch(this.bad_answer)
  },
  getSimcardTariffList(callback) {
    Request.get('simcard-profile/mno-tariffs').then(callback).catch(this.bad_answer)
  },
  getSimcardActions(id, callback) {
    Request.get('simcard-profile/get-actions/'+ id).then(callback).catch(this.bad_answer)
  },
  getSimcardActionsHistory(callback) {
    Request.get('simcard-profile/actions-history').then(callback).catch(this.bad_answer)
  },
  runSimcardActions(id, action, protocol, params, callback) {
    Request.post('simcard-profile/run-action/'+ id +'?action='+action +'&protocol='+protocol, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  runNewSimcardActions(id, params, callback) {
    Request.post('simcard-profile/run-action-new/'+ id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getAllSimcards(params, callback) {
    Request.get('simcard-profile/get-sims', params).then(callback).catch(this.bad_answer)
  },
  getSimcardImsi(params, callback) {
    Request.get('simcard-profile/get-msisdn', params).then(callback).catch(this.bad_answer)
  },
  putSimcardApn(id, params, callback) {
    Request.put('simcard-profile/' + id + '/apn', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  deleteSimcardApn(id, callback) {
    Request.delete('simcard-profile/' + id + '/apn').then(callback).catch(this.bad_answer)
  },
  putSimcardStatus(id, params, callback) {
    Request.put('simcard-profile/' + id + '/status', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default SimcardProfile
